<script setup>
    import { ElCollapseItem, ElInput, ElSelect, ElOption } from 'element-plus';
    import { ref } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useProductStore } from '../../stores/fpe';
    import { ArrowRightBold } from '@element-plus/icons-vue'

    const store = useProductStore();
    const { product, data_sets, strings } = storeToRefs(store);

    const isShippingApplicable = ref(false);
    if(product.value.type == 'simple' || product.value.type == 'variable'){

        // check if simple product is virtual
        if(product.value.type == 'simple' && product.value.virtual == true){
            isShippingApplicable.value = false;
        }else{
            isShippingApplicable.value = true;
        } 
    }

</script>

<template>
    <el-collapse-item v-if="isShippingApplicable" :title="strings.section_title_shipping" class="fpe-section-shipping" name="shipping" :icon="ArrowRightBold">
        <div class="fpe-field-wrapper" data-field="weight">
            <label>{{ strings.label_weight }}</label>
            <ElInput v-model="product.weight" />
        </div>

        <div class="fpe-field-wrapper fpe-dimensions" data-field="dimensions">
            <label>{{ strings.label_dimensions }}
                <Info :tooltip_text="strings.tooltip_dimensions" />
            </label>
            <div class="fpe-dimension-fields">
                <ElInput v-model="product.length" />
                <ElInput v-model="product.width" />
                <ElInput v-model="product.height" />
            </div>
        </div>

        <div class="fpe-field-wrapper" data-field="shipping-class">
            <label>{{ strings.label_shipping_class }}</label>
            <ElSelect v-model="product.shipping_class_id">
                <ElOption
                    v-for="(value, name) in Object.entries(data_sets.shipping_classes)"
                    :key="value[0]"
                    :label="value[1]"
                    :value="value[0]"
                />
            </ElSelect>
        </div>

    </el-collapse-item>    

</template>